import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Sortable from 'sortablejs';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Util from 'root/module/util';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    events: {
        'change input[name="categories"]' : 'onChangeCategories',
        'input .colour-edit input.colour' : 'onStatusColourChange',
        'click .status-edit-name'         : 'onStatusEditName',
        'click .status-delete'            : 'onStatusDelete',
        'click .portal-status-add'        : 'onStatusAdd'
    },

    dom_handlers: {
        onChangeCategories: function(e) {
            var form_data = Form.getData(this.$el);

            Cache.app.request({
                action: 'portal/update',
                data: {
                    portal_id            : this.model.id,
                    categories           : form_data.categories
                },
                context: this,
                success: function(response) {
                    this.model.set(response);
                    UI.success('Portal settings updated');
                }
            });
        },

        onStatusColourChange: function(e) {
            var status_id = parseInt($(e.currentTarget).parents('.portal-status:first').data('val'), 10);
            var colour    = $(e.currentTarget).val();

            Cache.app.request({
                action: 'portal_status/update',
                data: {
                    id     : status_id,
                    colour : colour
                },
                success: function(response) {
                    Cache.portal_status.get(status_id).set(response);
                    UI.success('Status colour updated');
                }
            });
        },

        onStatusEditName: function(e) {
            var container = $(e.currentTarget).parents('.portal-status');
            var status_id = parseInt(container.data('val'), 10);

            Modals.editPortalStatusName(status_id, function(status_name) {
                container.find('.status-name').text(status_name);
            });
        },

        onStatusDelete: function(e) {
            var container = $(e.currentTarget).parents('.portal-status');
            var status_id = parseInt(container.data('val'), 10);

            Modals.deletePortalStatus(status_id, function() {
                container.remove();
            });
        },

        onStatusAdd: function(e) {
            e.preventDefault();

            Modals.addPortalStatus(function(status_model) {
                var ele = $(this.getStatusHtml(status_model.id)).appendTo(this.$el.find('.region-portal-status'));
                this.droppable(ele);
            }.bind(this));
        }
    },

    droppable: function(element) {
        element.droppable({
            addClasses: false,
            accept: '.workflow-name',
            drop: function(e, ui) {
                var workflow_id = parseInt(ui.helper.data('val'), 10);
                var status_id   = parseInt(element.data('val'), 10);

                // create workflow element
                var workflow_html    = this.getWorkflowHtml(workflow_id);
                var workflow_element = $(workflow_html).appendTo(element.find('.workflow-names'));
                this.draggable(workflow_element);

                // remove the original one
                ui.helper.remove();

                // save
                Cache.app.request({
                    action: 'portal_status/updateWorkflow',
                    data: {
                        workflow_id : workflow_id,
                        status_id   : status_id
                    },
                    success: function(response) {
                        Cache.workflow.get(workflow_id).set('portal_status_id', status_id);
                        UI.success('Status updated');
                    }
                });
            }.bind(this)
        });
    },

    draggable: function(elements) {
        elements.draggable({
            addClasses: false,
            revert: 'invalid',
            distance: 5,
            scroll: false,
            appendTo: document.body,
            start: function(e, ui) {
                $(this).parents('.portal-status').droppable('disable');
            },
            stop: function(e, ui) {
                // cant use this because the element is appended to a different parent
                $('.portal-status.ui-droppable-disabled').droppable('enable');
            }
        });
    },

    onRender: function() {
        // sortable
        const el = this.$el.find('.region-portal-status').get(0);

        if (el) {
            new Sortable(el, {
                ghostClass: 'drag-placeholder',
                handle: '.drag-handle',
                onSort: function() {
                    var do_update = false;

                    this.$el.find('.portal-status').each(function(sort, element) {
                        var status_id = parseInt($(this).data('val'), 10);

                        if (sort !== Cache.portal_status.get(status_id).get('sort')) {
                            do_update = true;

                            Cache.app.request({
                                action: 'portal_status/update',
                                data: {
                                    id : status_id,
                                    sort : sort
                                },
                                success: function(response) {
                                    Cache.portal_status.get(status_id).set(response);
                                }
                            });
                        }
                    });

                    if (do_update) {
                        UI.success('Status updated');
                    }
                }.bind(this)
            });
        }

        // droppable
        this.$el.find('.portal-status').each(function(index, element) {
            this.droppable($(element));
        }.bind(this));

        this.draggable(this.$el.find('.workflow-name'));
    },

    getStatusHtml: function(status_id) {
        var model = Cache.portal_status.get(status_id);

        var workflow_options = '';

        Cache.workflow.where({project_id: this.model.get('project_id'), portal_status_id: model.id}).forEach(function(workflow) {
            workflow_options += this.getWorkflowHtml(workflow.id);
        }.bind(this));

        var html =
        '<div class="portal-status" data-val="' + model.id + '">' +
            '<span class="drag-handle"></span>' +
            '<div class="drag-placeholder-highlight">' +
                '<div class="status-name">' + model.escape('status_name') + '</div>' +
                '<div class="workflow-names">' + workflow_options + '</div>' +
                '<div class="colour-edit">' +
                    '<input type="text" class="colour compact" spellcheck="false" value="' + model.escape('colour') + '">' +
                    '<div class="colour-indicator" style="background-color:' + model.escape('colour') + '"></div>' +
                '</div>' +

                '<div class="button-dropdown">' +
                    '<button type="button" class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                    '<div>' +
                        '<ul class="dropdown">' +
                            '<li class="status-edit-name">Edit Name</li>' +
                            '<li class="status-delete">Delete</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        return html;
    },

    getWorkflowHtml: function(workflow_id) {
        var workflow = Cache.workflow.get(workflow_id);
        var colour   = workflow.get('colour');
        var name     = workflow.escape('name');

        return '<span style="color:' + colour + ';border-color:' + Util.hexToRgba(colour, 0.4, true) + ';background-color:' + Util.hexToRgba(colour, 0.04, true) + ';" class="workflow-name" data-val="' + workflow_id + '"><i class="far fa-arrows"></i> ' + name + '</span>';
    },

    render: function() {
        var category_options = '';

        Cache.feedback_category.where({project_id: this.model.get('project_id')}).forEach(function(model) {
            var id = _.uniqueId('c_');

            category_options +=
            '<div class="margin-bottom-4">' +
                '<input id="' + id + '" type="checkbox" name="categories" value="' + model.escape('name') + '">' +
                '<label class="font-weight-medium" for="' + id + '">' + model.escape('name') + '</label>' +
            '</div>';
        });

        var status_options = '';
        Cache.portal_status.where({portal_id: this.model.id}).forEach(function(model) {
            status_options += this.getStatusHtml(model.id);
        }.bind(this));

        var unassigned_workflows = '';

        Cache.workflow.where({project_id: this.model.get('project_id')}).forEach(function(workflow) {
            if (!Cache.portal_status.get(workflow.get('portal_status_id'))) {
                unassigned_workflows += this.getWorkflowHtml(workflow.id);
            }
        }.bind(this));

        var content =
        '<div class="box box-nopadding">' +
            '<div class="padding-32">' +
                '<div>' +
                    '<h3>Public status</h3>' +
                    '<div class="text-info text-medium padding-right-24">These are the status displayed in your ideas portal. You can drag and drop <i class="far fa-arrows"></i> the internal status labels to customize how feedback is labelled in the ideas portal.</div>' +
                '</div>' +
                '<div class="divider-24"></div>' +
                '<div>' +
                    '<div class="region-portal-status">' + status_options + '</div>' +
                    '<div class="region-portal-status-unassigned">' + unassigned_workflows + '</div>' +
                    '<a class="portal-status-add primary" href="#"><i class="far fa-plus margin-right-4"></i>Add status</a>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="padding-32">' +
                '<div>' +
                    '<h3>Category</h3>' +
                    '<div class="text-info text-medium padding-right-24">Choose what feedback categories to show on your ideas portal. These are also the categories people can choose when submitting a new idea.</div>' +
                '</div>' +
                '<div class="divider-24"></div>' +
                '<div>' +
                    category_options +
                '</div>' +
            '</div>' +

            '<button type="submit" class="hidden">Submit</button>' +
        '</div>';

        this.$el.html(content);

        Form.setData(this.$el, {
            categories: this.model.get('categories').split(',')
        });

        this.onRender();

        return this;
    }
});